module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('warranty.label'),
      "required": true,
      "error": _vm.getError('product.warranty', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.warranty),
      expression: "product.warranty"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.product.warranty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "warranty", $event.target.value)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e755a07a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/webcontinental/provide/Product.vue
// module id = 3469
// module chunks = 0